import { useDispatch } from 'react-redux';
import { jobTypeMap } from 'modules/jobManager/constants';
import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { setCreationTakeoverState } from 'modules/jobManager/ducks/actions';
import { JOB_TYPE } from 'modules/jobManager/types';
import { Add16 } from 'ui/icons/action/Add16';
import { ChevronDownSmall } from 'ui/icons/navigation/ChevronDownSmall';
import { BUTTON_SIZES, Button } from 'ui/button';
import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { colors } from 'ui/theme/colors';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { FilterButton } from './facet/FilterButton';
import { PageActionWrapper, StyledPageHeader } from './Styled';

const PageActions = () => {
  const { t } = useJobManagerTranslations();
  const dispatch = useDispatch();

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: <span>{jobTypeMap[JOB_TYPE.EXPORT_JOB]}</span>,
      id: JOB_TYPE.EXPORT_JOB,
      onClick: () => dispatch(setCreationTakeoverState(true)),
    },
  ];

  return (
    <PageActionWrapper>
      <FilterButton />
      <ActionMenu options={options}>
        <Button size={BUTTON_SIZES.LARGE}>
          <Add16 color={colors.white} />
          <span>{t('button.newJob')}</span>
          <ChevronDownSmall color={colors.white} />
        </Button>
      </ActionMenu>
    </PageActionWrapper>
  );
};

export const JobManagerHeader = () => {
  const { t } = useJobManagerTranslations();
  return (
    <StyledPageHeader data-test="job-manager-index-page-header" pageActions={<PageActions />}>
      {t('title.header')}
    </StyledPageHeader>
  );
};
